import React from "react";
import { Icon } from "../icon/Icon.jsx";

/* Ringover IconButton — square, icon-only control.
   The glassy nav-rail cells, dialer actions and row actions are all this. */

const SIZES = {
  sm: { box: 32, icon: 18, radius: "var(--radius-sm)" },
  md: { box: 40, icon: 22, radius: "var(--radius-sm)" },
  lg: { box: 48, icon: 24, radius: "var(--radius-sm)" },
};

const VARIANTS = {
  /* frosted cell used in the icon rail */
  glass: { background: "var(--rg-white-a40)", color: "var(--color-accent)", glass: true },
  /* soft light-blue fill */
  grey: { background: "var(--rg-grey-300)", color: "var(--text-body)", glass: false },
  /* transparent, hover reveals a soft fill */
  ghost: { background: "transparent", color: "var(--text-body)", glass: false },
  /* solid brand */
  primary: { background: "var(--rg-empower-600)", color: "var(--text-on-brand)", glass: false },
};

export function IconButton({
  icon,
  size = "md",
  variant = "ghost",
  active = false,
  disabled = false,
  "aria-label": ariaLabel,
  style,
  ...rest
}) {
  const s = SIZES[size] || SIZES.md;
  const v = VARIANTS[variant] || VARIANTS.ghost;
  const [hover, setHover] = React.useState(false);
  const [press, setPress] = React.useState(false);

  const bg = active ? "var(--color-accent-soft)" : v.background;
  const fg = active ? "var(--color-accent)" : v.color;

  return (
    <button
      type="button"
      aria-label={ariaLabel}
      aria-pressed={active}
      disabled={disabled}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => { setHover(false); setPress(false); }}
      onMouseDown={() => setPress(true)}
      onMouseUp={() => setPress(false)}
      style={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        width: s.box,
        height: s.box,
        flexShrink: 0,
        color: fg,
        background: bg,
        backdropFilter: v.glass ? "var(--blur-glass)" : "none",
        WebkitBackdropFilter: v.glass ? "var(--blur-glass)" : "none",
        boxShadow: v.glass ? "var(--shadow-glass)" : "none",
        border: "none",
        borderRadius: s.radius,
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.45 : 1,
        transform: press && !disabled ? "scale(0.92)" : "scale(1)",
        transition: "transform var(--duration-fast) var(--ease-standard), background var(--duration-base) var(--ease-standard)",
        backgroundImage: hover && !disabled && !active
          ? "linear-gradient(rgba(0,73,97,0.06),rgba(0,73,97,0.06))"
          : "none",
        ...style,
      }}
      {...rest}
    >
      <Icon name={icon} size={s.icon} />
    </button>
  );
}

export default IconButton;
